import { Box, Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface ChartContainerProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function ChartContainer({ title, subtitle, children }: ChartContainerProps) {
  return (
    <Paper
      sx={{
        p: { xs: 2, sm: 3 },
        background: '#ffffff',
        borderRadius: 3,
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12)',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        '@media (hover: hover)': {
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 36px rgba(0, 0, 0, 0.16)',
          },
        },
      }}
      elevation={0}
    >
      <Box mb={{ xs: 2, sm: 3 }}>
        <Typography variant="h6" fontWeight="600" sx={{ color: '#1a1a1a', mb: 0.5 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: '#666666' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {children}
    </Paper>
  );
}
